// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1gopk","expandIcon":"AccordionButton_expandIcon__3S5oW","expanded":"AccordionButton_expanded__27_wr"};